import {config} from "./config";
import {request} from "./request";

function createOrUpdateCategory(data, cb, fail_cb) {
    request.post.call(this, config.apiList.userProductCategories, data, null, cb, fail_cb)
}


function getUserProductCategories(data, cb, fail_cb) {
    request.get.call(this, config.apiList.userProductCategories, data, cb, fail_cb)
}

function deleteCategory(data, cb, fail_cb) {
    request.deleteRequest.call(this, config.apiList.userProductCategories + "/" + data.id, data, cb, fail_cb)
}

function getUserProductCategoryShareImg(data, cb, fail_cb) {
    request.get.call(this, config.apiList.userProductCategories + '/userProductCategoryShareImg', data, cb, fail_cb)
}


var userProductCategoryApi = {
    createOrUpdateCategory: createOrUpdateCategory,
    deleteCategory: deleteCategory,
    getUserProductCategories: getUserProductCategories,
    getUserProductCategoryShareImg: getUserProductCategoryShareImg
}

export {userProductCategoryApi}